<aside class="sidebard-bg pull-left show-mobile-menu mobile-menu-asidebar" *ngIf="isLab">
  <div class="admin-logo pull-left mb-3 mt-3 mobile-partition">
    <img src="assets/image/admin-logo.png" class="img-fluid" />
    
    <button (click)="Mobile_sidebar_menu_btn()" class="mobile-menu-close-btn mobile-menu-btn" style="color: #fff; top: 0px; right: 15px;"><i class="far fa-times-circle" ></i></button>
  
  </div>
  <ul class="dashboard-asidebar">
    <li [routerLinkActive]="['active-dashboard']">
      <a [routerLink]="['/lab-dashboard']" class="responsive-design"
        ><i class="fas fa-tachometer-alt"></i> Dashboard</a
      >
    </li>
    <li [routerLinkActive]="['active-dashboard']">
      <a [routerLink]="['/loggedsamples']" class="responsive-design"
        ><i class="fas fa-microscope"></i> Logged Samples</a
      >
    </li>
    <li [routerLinkActive]="['active-dashboard']">
      <a [routerLink]="['/results']" class="responsive-design"
        ><i class="far fa-thumbs-up"></i> Results</a
      >
    </li>
    <!-- <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/lab-dashboard']"><i class="far fa-calendar-check"></i> Default Appointments</a></li> -->
    <li class="relative-menu" *ngIf="roleID != env.private_laboratory_user">
      <a class="dropDownToggle">
        <i class="fas fa-vials"></i> Manage Lab Users
        <i class="fas fa-angle-down" style="margin-left: 5px"></i
      ></a>
      <ul class="dropDownToggle-menu">
        <li [routerLinkActive]="['active-dashboard']">
          <a  [routerLink]="['/labusers']" class="responsive-design"
            ><i class="fas fa-chevron-right"></i> User</a
          >
        </li>
        <li [routerLinkActive]="['active-dashboard']">
          <a  [routerLink]="['/useractivities']" class="responsive-design"
            ><i class="fas fa-chevron-right"></i> User Activities</a
          >
        </li>
        <!-- <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/adduser']"><i class="far fa-circle"></i> Add User</a></li> -->
      </ul>
    </li>
    <li class="relative-menu" *ngIf="roleID != env.private_laboratory_user">
      <a class="dropDownToggle2">
        <i class="far fa-hospital"></i> Manage Collection Centers
        <i class="fas fa-angle-down" style="margin-left: 5px"></i
      ></a>
      <ul class="dropDownToggle2-menu">
        <li [routerLinkActive]="['active-dashboard']">
          <a  [routerLink]="['/collectioncenters']" class="responsive-design"
            ><i class="fas fa-chevron-right"></i> Collection Centers</a
          >
        </li>
        <li [routerLinkActive]="['active-dashboard']">
          <a  [routerLink]="['/employees']" class="responsive-design"
            ><i class="fas fa-chevron-right"></i> Employees</a
          >
        </li>
      </ul>
    </li>

    <!-- <li [routerLinkActive]="['active-dashboard']"><a [routerLink]="['/lab-dashboard']"><i class="far fa-calendar-check"></i> Payment Log</a></li> -->
  </ul>
</aside>
